/**
 * Cost-edit constants for PropWise
 */

export const COST_EDIT = {
  /**
   * Largest per-item cost override the report page will save, in whole dollars.
   * The backend's PATCH item handler only rejects negatives, so this is a
   * client-side guard against a fat-fingered value reaching the share email.
   */
  MAX_ITEM_COST: 1000000,
} as const;
